import { SVGProps } from 'react';

function VoteUpIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <mask id="mask0_5151_1428" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="17">
        <rect y="0.4375" width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5151_1428)">
        <path d="M5.33333 13.7708V9.10418H3.4C3.11111 9.10418 2.90833 8.97918 2.79167 8.72918C2.675 8.47918 2.70556 8.24306 2.88333 8.02084L7.48333 2.40417C7.61667 2.23751 7.78889 2.15417 8 2.15417C8.21111 2.15417 8.38333 2.23751 8.51667 2.40417L13.1167 8.02084C13.2944 8.24306 13.325 8.47918 13.2083 8.72918C13.0917 8.97918 12.8889 9.10418 12.6 9.10418H10.6667V13.7708C10.6667 13.9597 10.6028 14.1181 10.475 14.2458C10.3472 14.3736 10.1889 14.4375 10 14.4375H6C5.81111 14.4375 5.65278 14.3736 5.525 14.2458C5.39722 14.1181 5.33333 13.9597 5.33333 13.7708Z" fill="currentColor" />
      </g>
    </svg>
  );
}

export default VoteUpIcon;
